import {Component, forwardRef, Input} from "@angular/core";
import {FormBuilder, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {map} from "rxjs/operators";
import {SupervisorService} from "../../../core/services/supervisor.service";
import {AbstractControlComponent} from "../../abstract-control-value-accessor/abstract-control.component";

@Component({
  selector: "app-search-supervisor",
  templateUrl: "./search-supervisor.component.html",
  styleUrls: ["./search-supervisor.component.css"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchSupervisorComponent),
      multi: true,
    },
  ],
})
export class SearchSupervisorComponent extends AbstractControlComponent {
  @Input() required = false;
  @Input() lessorId: number;
  supervisorForm: FormControl;

  constructor(private formBuilder: FormBuilder,
              private supervisorService: SupervisorService) {
    super();
    this.createForm();
  }

  writeValue(supervisorId: any): void {
    if (supervisorId == null) {
      this.supervisorForm.reset();
    } else {
      this.supervisorForm.setValue(supervisorId);
    }
  }

  registerOnChange(fn: any): void {
    this.supervisorForm.valueChanges.subscribe(value => fn(value || null));
  }


  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.supervisorForm.disable() : this.supervisorForm.enable();
  }

  ngOnInit(): void {
  }

  public supervisorSearchFunction = (text: string, page: number, size: number) => {
    return this.supervisorService.search(text, page, size, this.lessorId).pipe(
      map(supervisors => supervisors.toSimpleSelectableDataList())
    );
  }

  public supervisorFindByIdFunction = (supervisorId: number) => {
    return this.supervisorService.getOne(supervisorId).pipe(
      map(supervisor => supervisor.toSelectText())
    );
  }

  private createForm(): void {
    this.supervisorForm = this.formBuilder.control(null);
  }

  clear(): void {
    this.supervisorForm.reset();
  }
}
